import { Link, useLocation } from "react-router-dom";
import { PrivacyContent, TermsContent } from "@/components/LegalContent";

export default function Legal() {
  const pathname = useLocation().pathname;
  const privacy = pathname.endsWith("/privacy");
  const membership = pathname.startsWith("/membership/onp-wa/");
  const variant = membership ? "membership" : "campaign";
  const organisation = membership ? "One Nation Western Australia" : undefined;
  const termsPath = membership ? "/membership/onp-wa/terms" : "/terms";
  const privacyPath = membership ? "/membership/onp-wa/privacy" : "/privacy";
  return <main className="min-h-screen bg-neutral-50 text-neutral-900 px-6 py-10 sm:py-16" data-testid="legal-page">
    <div className="max-w-3xl mx-auto min-w-0 break-words">
      <nav className="flex flex-wrap gap-5 border-b pb-5 mb-10" aria-label="Legal pages">
        <Link to={membership ? "/membership/onp-wa" : "/login"} data-testid="legal-login-link" className="font-semibold">{organisation || "Civipen"}</Link>
        <Link to={termsPath} data-testid="legal-terms-link" className="underline">Terms</Link>
        <Link to={privacyPath} data-testid="legal-privacy-link" className="underline">Privacy</Link>
      </nav>
      <h1 data-testid="legal-title" className="text-4xl sm:text-5xl mb-10 uppercase" style={{ fontFamily: "'Playfair Display', serif" }}>{privacy ? "Privacy Notice" : "Terms & Conditions"}</h1>
      {privacy ? <PrivacyContent organisation={organisation} variant={variant} /> : <TermsContent organisation={organisation} variant={variant} />}
    </div>
  </main>;
}